<template>
  <validation-observer
    ref="originRules"
    v-slot="{ invalid }"
    tag="form"
  >
    <b-row class="justify-content-center">
      <b-col
        cols="12"
        lg="8"
      >
        <div
          class="powered-by d-flex justify-content-end align-items-center mb-2 mt-1"
        >
          <span class="text-secondary mr-1 text-xsm">
            powered by
          </span>
          <img
            :src="require('@/assets/images/logo/porta-logo.png')"
            alt="PortaLogo"
            class="porta-lo"
          >
        </div>
        <div
          v-if="!profileInformation && fetchingProfileInformation"
          class="text-center py-4"
        >
          <b-spinner />
        </div>
        <template v-if="profileInformationForm">
          <paper-simple body-class="py-2">
            <div class="d-flex align-items-center justify-content-between">
              <div class="px-2 d-flex align-items-center">
                <div>
                  <div
                    class="rounded-full profile_image"
                    :style="
                      profileInformation.picture
                        ? `background-image:url(${profileInformation.picture})`
                        : ''
                    "
                  />
                </div>
                <h5 class="name mb-0 ml-2">
                  {{ profileInformation.firstName }}
                  {{ profileInformation.lastName }}
                </h5>
              </div>
              <div class="d-flex align-items-center" />
            </div>
          </paper-simple>

          <paper-simple>
            <div class="px-2">
              <b-row>
                <b-col>
                  <validation-provider
                    #default="{ errors }"
                    name="First name"
                    rules="required|alpha"
                  >
                    <input-field
                      name="profile-first_name"
                      label="First name"
                      label-position="top"
                      info-position="label"
                      :error="errors.length ? errors[0] : null"
                    >
                      <b-form-input
                        id="profile-first_name"
                        v-model.trim="profileInformationForm.firstName"
                        placeholder="Enter first name..."
                        :state="errors.length > 0 ? false : null"
                      />
                    </input-field>
                  </validation-provider>
                </b-col>
                <b-col>
                  <validation-provider
                    #default="{ errors }"
                    name="Last name"
                    rules="required|alpha"
                  >
                    <input-field
                      name="profile-last_name"
                      label="Last name"
                      label-position="top"
                      info-position="label"
                      :error="errors.length ? errors[0] : null"
                    >
                      <b-form-input
                        id="profile-last_name"
                        v-model.trim="profileInformationForm.lastName"
                        placeholder="Enter last name..."
                        :state="errors.length > 0 ? false : null"
                      />
                    </input-field>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <validation-provider
                    #default="{ errors }"
                    name="Birthday"
                    rules="required"
                  >
                    <input-field
                      name="profile-birthday"
                      label="Birthday"
                      label-position="top"
                      info-position="label"
                      :error="errors.length ? errors[0] : null"
                    >
                      <b-form-input
                        id="profile-first_name"
                        v-model="profileInformationForm.birthdate"
                        :state="errors.length > 0 ? false : null"
                        type="date"
                        :max="maxBirthdate.toString()"
                      />
                    </input-field>
                  </validation-provider>
                </b-col>
                <b-col>
                  <validation-provider
                    #default="{ errors }"
                    name="Gender"
                    rules="required"
                  >
                    <input-field
                      name="profile-gender"
                      label="Gender"
                      label-position="top"
                      info-position="label"
                      :error="errors.length ? errors[0] : null"
                    >
                      <custom-select
                        v-model="profileInformationForm.gender"
                        :options="genderOptions"
                      />
                    </input-field>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <input-field
                    name="phone-number"
                    label="Phone Number"
                    label-position="top"
                    info-position="label"
                  >
                    <MazPhoneNumberInput
                      v-model="profileInformationForm.phoneNumber"
                      class="phone-number"
                      :default-phone-number="profileInformationForm.phoneNumber"
                    />
                  </input-field>
                </b-col>
              </b-row>
            </div>
          </paper-simple>
        </template>
      </b-col>
    </b-row>
    <b-row
      v-if="profileInformationForm"
      class="justify-content-center mt-2"
    >
      <b-col
        cols="12"
        md="10"
      >
        <div
          class="d-flex justify-content-end py-2 border-default border-t mt-1"
        >
          <b-button
            variant="bg-white"
            :to="{ name: 'profile' }"
          >
            Cancel
          </b-button>
          <b-button
            variant="bg-primary"
            class="ml-1"
            :disabled="invalid || savingProfileInformation"
            @click="saveProfileInformation"
          >
            Save
            <b-spinner
              v-if="savingProfileInformation"
              class="position-absolute"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { required } from '@validations'
import MazPhoneNumberInput from 'maz-ui/lib/maz-phone-number-input'
import 'maz-ui/lib/css/maz-phone-number-input.css'

export default {
  name: 'UpdateProfile',
  components: {
    ValidationObserver,
    MazPhoneNumberInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
      phoneNumber: null,
      test: '',
      maxBirthdate: null,
      profileInformationForm: null,
      genderOptions: [
        { text: 'Female', value: 'female' },
        { text: 'Male', value: 'male' },
        { text: 'Rather not say', value: 'rather not say' },
      ],
    }
  },
  computed: {
    profileInformation() {
      return this.$store.state.profile.profileInformation
    },
    fetchingProfileInformation() {
      return this.$store.state.profile.fetchingProfileInformation
    },
    savingProfileInformation() {
      return this.$store.state.profile.savingProfileInformation
    },
  },
  created() {
    this.maxBirthdate = new Date()
    this.fetchProfileInformation()
  },
  methods: {
    fetchProfileInformation() {
      this.$store.dispatch('profile/fetchProfileInformation').then(res => {
        this.profileInformationForm = {
          ...res.data,
          birthdate: this.getBirthdate(res.data.birthdate),
        }
      })
    },
    getBirthdate(str) {
      if (str) {
        const tempArr = str.split('/')
        if (tempArr.length < 2) return str
        return `${tempArr[2]}-${tempArr[0]}-${tempArr[1]}`
      }
      return str
    },
    setBirthdateToDefault(str) {
      if (str) {
        const tempArr = str.split('-')
        if (tempArr.length < 2) return str
        return `${tempArr[1]}/${tempArr[2]}/${tempArr[0]}`
      }
      return str
    },
    saveProfileInformation() {
      this.$store
        .dispatch('profile/saveProfileInformation', {
          ...this.profileInformationForm,
          birthdate: this.setBirthdateToDefault(
            this.profileInformationForm.birthdate,
          ),
        })
        .then(() => {
          this.$router.push({
            name: 'profile',
            params: {
              toast: {
                title: 'Success',
                variant: 'success',
                message: 'Profile updated successfully!',
              },
            },
          })
        })
        .catch(() => {
          this.$router.push({
            name: 'profile',
            params: {
              toast: {
                title: 'Error',
                variant: 'error',
                message: "Couldn't update profile!",
              },
            },
          })
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables/variables';

.porta-link {
  color: $primary;
  span {
    margin-right: 5px;
  }
}

.profile_image {
  background-color: $white-300;
  width: 73px;
  height: 73px;
  border-radius: 100%;
  background-size: cover;
  border: 1px solid $gray-100;
}
.name {
  color: $blue-700;
}
.powered-by {
  img {
    width: 80px;
  }
}

.phone-number::v-deep {
  width: 100%;
  display: flex;
  .maz-border {
    border-radius: 5px;
    border: 1px solid #e0e5eb;
  }

  .maz-input {
    position: relative;
    background-color: #ffffff;
    transition: all 300ms ease-in-out;
    height: 3rem;
    min-height: 3rem;
  }

  .maz-input__label {
    position: absolute;
    top: 0.125rem;
    cursor: pointer;
    outline: none;
    left: 0.8571rem;
    transform: translateY(25%);
    opacity: 0;
    transition: all 300ms ease-in-out;
    font-size: 0.786rem;
    color: #a7a7a7;
  }

  .maz-input__input {
    cursor: pointer;
    transition-duration: 0.3s;
    position: relative;
    width: 100%;
    padding: 0 0.8571rem;
    color: #052d61;
    font-weight: 400;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    outline: none;
    font-size: 1rem;
    z-index: 0;
    background-color: transparent;
    display: block;
    height: 100%;

    &::-webkit-input-placeholder {
      color: #a7a7a7;
    }

    &::-moz-placeholder {
      color: #a7a7a7;
    }

    &:-ms-input-placeholder {
      color: #a7a7a7;
    }

    &::-ms-input-placeholder {
      color: #a7a7a7;
    }

    &::placeholder {
      color: #a7a7a7;
    }
  }

  .maz-input__icon.left {
    left: 0.5714rem;
  }

  .maz-input__icon.right {
    right: 0.5714rem;
  }

  .maz-input__toggle-btn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0.5714rem;
    margin: auto 0;
    width: 1.714rem;
    height: 1.714rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    background: transparent;
    color: #052d61;
    border-radius: 1.714rem;
    cursor: pointer;
    font-size: 1rem;
    transition: all 300ms ease-in-out;

    &:focus {
      outline: none;
    }

    .maz-input__toggle-btn__icon {
      display: none;
    }

    &:after {
      display: inline-block;
      content: '\00d7';
    }
  }

  .maz-input__toggle-btn__icon {
    position: relative;
    font-size: 1.286rem;
  }

  .maz-input.has-1-right-icon .maz-input__input {
    padding-right: 2.5rem;
  }

  .maz-input.has-2-right-icon .maz-input__input {
    padding-right: 4.643rem;
  }

  .maz-input.has-3-right-icon .maz-input__input {
    padding-right: 6.786rem;
  }

  .maz-input.has-value .maz-input__label,
  .maz-input.has-hint .maz-input__label {
    opacity: 1;
    transform: translateY(0);
  }

  .maz-input.has-value:not(.has-no-label).is-textarea,
  .maz-input.has-hint:not(.has-no-label).is-textarea {
    padding-top: 1.429rem;
  }

  .maz-input.has-value:not(.has-no-label) .maz-input__input,
  .maz-input.has-hint:not(.has-no-label) .maz-input__input {
    padding-top: 1rem;
  }

  .maz-input--sm {
    height: 2.571rem;
    min-height: 2.571rem;
    .maz-input__input {
      font-size: 0.857rem;
    }

    .maz-input__label {
      font-size: 0.714rem;
      top: 0.0625rem;
    }
  }

  .maz-input--sm.has-value:not(.has-no-label) .maz-input__input {
    padding-top: 0.8571rem;
  }

  .maz-input--sm.has-value:not(.has-no-label) .maz-input__input.maz-textarea {
    padding-top: 1.286rem;
  }

  .maz-input--lg {
    height: 3.571rem;
    min-height: 3.571rem;
    .maz-input__input {
      font-size: 1.143rem;
    }

    .maz-input__label {
      font-size: 1rem;
      top: 0.1875rem;
    }
  }

  .maz-input--lg.has-value:not(.has-no-label) .maz-input__input {
    padding-top: 1.143rem;
  }

  .maz-input--lg.has-value:not(.has-no-label) .maz-input__input.maz-textarea {
    padding-top: 1.857rem;
  }

  .maz-input__loader.maz-textarea {
    bottom: 0.4286rem;
  }

  .maz-select {
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .maz-select--sm {
    font-size: 0.857rem;
  }

  .maz-select--lg {
    font-size: 1.143rem;
  }

  .maz-select__options-list {
    z-index: 9;
    padding: 0;
    margin: 0;
    position: absolute;
    overflow: hidden;
    border-radius: 5px;
    background-color: #ffffff;
  }

  .maz-select__options-list:not(.maz-select__options-list--top) {
    top: 100%;
  }

  .maz-select__options-list--top {
    bottom: 100%;
  }

  .maz-select__options-list--right {
    right: 0;
  }

  .maz-select__options-list__items {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .maz-select__options-list__item {
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 1em;
    cursor: pointer;
    background-color: transparent;
    border: none;
    color: #052d61;
    outline: none;
    transition: all 300ms ease-in-out;
  }

  .maz-select__options-list__item:hover,
  .maz-select__options-list__item.keyboard-selected {
    background-color: #eeeeee;
  }

  .maz-select__options-list__no-results i {
    font-size: 2.3rem;
  }

  .maz-select.has-list-open .maz-select__toggle {
    transform: rotate(180deg);
  }

  .maz-border-color {
    border-color: #eeeeee;
  }

  .maz-border-solid {
    border-style: solid;
  }

  .maz-flex {
    display: flex;
  }

  .maz-direction-column {
    flex-direction: column;
  }

  .maz-align-center {
    align-items: center;
  }

  .maz-flex-center {
    justify-content: center;
    align-items: center;
  }

  .maz-flex-1 {
    flex: 1;
  }

  .maz-text-left {
    text-align: left;
  }

  .maz-text-right {
    text-align: right;
  }

  .maz-mr-2 {
    margin-right: 0.5rem;
  }

  @media screen and (max-width: 455px) {
    .maz-input.has-1-right-icon .maz-input__input {
      padding-right: 0;
    }
    .maz-input__input {
      padding: 0 3px 0 3px;
      font-size: 0.9rem;
      width: 100%;
    }
    .maz-input__toggle-btn {
      padding-right: 3px;
      padding-left: 3px;
      margin-top: 0px;
      right: 0.2rem;
    }
    .maz-input__label {
      left: 0.3rem;
      font-size: 0.75rem;
    }

    .maz-base-component.maz-select.country-selector.maz-select--primary.maz-select--null {
      flex: 0 0 5.8rem;
      width: 5.8rem;
      min-width: 5.8rem;
      max-width: 5.8rem;
    }
  }
}
</style>
